"use strict";
define(
'stores/rsvps',[
	"jquery",
	"underscore",
	"stores/store",
	"actions/rsvps",
	"constants/actiontypes"
],
function ($, _, StoreBase, Action, Constants)
{
	Store.prototype = new StoreBase();
	Store.constructor = Store;

	var PAGE_SIZE = 10;

	function Store (params)
	{
		// Call parent constructor
		StoreBase.call(this, params);

		this.registerDispatchListener(function (action) {
			switch(action.actionType) {
				case Constants.ADD_RSVP:
					if(Array.isArray(action.data)) {
						_.each(action.data, function (data, index, list) {
							this.addRSVP(data);
						}, this);
					}
					else {
						this.addRSVP(action.data);
					}
					this.event.emit("change");
					break;
				case Constants.INIT_RSVP_COMMENT:
					this.initRSVPComment(action.guid, action.data);
					this.event.emit("change");
					break;
				case Constants.REMOVE_RSVP_COMMENT:
					this.removeRSVPComment(action.data);
					this.event.emit("change");
					break;
			}
		}.bind(this));

		this.action = new Action();
		this.rsvps = {};
	}

	Store.prototype.addRSVP = function(data) {
		this.rsvps[data.guid] = data;
	}

	Store.prototype.updateRSVP = function(data) {
		this.rsvps[data.guid] = data;
	}

	Store.prototype.initRSVPComment = function(guid, data) {
		if(this.rsvps[guid] && this.rsvps[guid].comments) {
			this.rsvps[guid].comments = data;
		}
	}

	Store.prototype.removeRSVPComment = function(data) {
		if(this.rsvps[data.guid] && this.rsvps[data.guid].comments) {
			var idx = _.findIndex(this.rsvps[data.guid].comments, function(comment) {
				return (comment.guid == data.guid);
			});

			this.rsvps[data.guid].comments.splice(idx, 1);
		}
	}

	Store.prototype.pull = function() {
		this.rsvps = {};
		this.action.pull();
	}

	Store.prototype.get = function(guid) {
		if(this.rsvps[guid.toLowerCase()]) {
			var ret = this.rsvps[guid.toLowerCase()];
			return ret;
		}

		return null;
	}
	
	return Store;
});

